import { AtpDeliveryInfoModel } from '../types/AtpDeliveryInfoModel';

const getLatestDeliveryInfoForKitSkus = (
	models: AtpDeliveryInfoModel[],
	kitSkuComponents: string[]
): AtpDeliveryInfoModel | null => {

	if (!models || models.length === 0 || !kitSkuComponents || kitSkuComponents.length === 0) {

		return null;

	}

	const allShortSkusMatch = models.every((m) => kitSkuComponents.includes(m.ShortSku));
	const latestDeliveryInfo = allShortSkusMatch && models.length === kitSkuComponents.length
		? models.reduce((latest, current) => {

			const latestDate = new Date(latest.DeliveryDate);
			const currentDate = new Date(current.DeliveryDate);
			return currentDate > latestDate ? current : latest;

		})
		: null;

	return latestDeliveryInfo;

};

export default getLatestDeliveryInfoForKitSkus;
